module.exports = __webpack_public_path__ + "img/news02.bc01560c.png";